// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.pagetop[data-v-5f0161be]{bottom:10px;opacity:1;position:fixed;right:30px;width:40px;z-index:15}@media screen and (max-width:767px){div.pagetop[data-v-5f0161be]{bottom:65px}}footer[data-v-5f0161be]{background:#90a2b1;bottom:0;position:fixed;width:100%;z-index:10}@media screen and (max-width:767px){footer[data-v-5f0161be]{position:relative}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
